import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get, has } from 'lodash';
import metrics from 'lib/common/metrics';
import { toCurrency } from 'lib/common/displayHelpers';

import { IconChevronUp, IconChevronRight } from 'components/Icons';
import SeatView from 'components/SeatView';

function upsellTitle(upsell) {
  let sectionDescription = get(upsell, 'seat.seatData.section_desc');
  if (sectionDescription) {
    return `Upgrade to ${sectionDescription}?`;
  } else {
    return 'Would you like to upgrade?';
  }
}

function upsellPriceDescription(upsell, fallback) {
  let prop = 'seat.seatData.section_details.Description';
  return get(upsell, prop, fallback);
}

function priceDifference(price, referencePrice) {
  price = parseInt(price, 10);
  referencePrice = parseInt(referencePrice, 10);
  return `+${toCurrency(price - referencePrice)}`;
}

class InlineSeatUpsell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasToggledSeatView: false
    };

    this.toggleSeatView = this.toggleSeatView.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
  }

  toggleSeatView() {
    this.setState({
      hasToggledSeatView: !this.state.hasToggledSeatView
    });
  }

  handleSelection(price) {
    const upsell = this.props.upsell;

    // Log Google Analytics custom event saying upsell was selected
    metrics.action(
      'Seat Upsell: Accepted Upsell',
      [
        'Upsell accepted from',
        upsell.referencePriceType.description,
        'to',
        upsell.seat.seatData.section_desc,
        'for performance',
        upsell.performanceId
      ].join(' ')
    );

    this.props.handleSelection(upsell.seat, price);
  }

  render() {
    return (
      <div className="syos-inline-upsell">
        <h3 className="syos-inline-upsell__title">
          {upsellTitle(this.props.upsell)}
        </h3>
        {has(this.props.upsell, 'seatView.image') && (
          <div className="syos-inline-upsell__seatview">
            <div
              className={classnames('syos-inline-upsell__seatview-image', {
                'is-toggled': this.state.hasToggledSeatView
              })}
            >
              <SeatView seatView={this.props.upsell.seatView} />
            </div>
            <button
              className="syos-inline-upsell__seatview-toggle u-syos-button-reset"
              onClick={this.toggleSeatView}
            >
              {this.state.hasToggledSeatView ? (
                <IconChevronUp />
              ) : (
                <IconChevronRight />
              )}
              {this.state.hasToggledSeatView
                ? 'Hide view from seat'
                : 'Show view from seat'}
            </button>
          </div>
        )}

        <ul className="syos-inline-upsell__pricetypes u-syos-unstyled-list">
          {this.props.upsell.prices.map(price => {
            return (
              <li key={price.price_type}>
                <div className="syos-pricetype-unit">
                  <span className="syos-pricetype-unit__details">
                    <span className="syos-price syos-price--stacked">
                      <span className="syos-price__description">
                        {upsellPriceDescription(
                          this.props.upsell,
                          price.price_type_desc
                        )}
                      </span>
                      <span className="syos-price__value">
                        {priceDifference(
                          price.price,
                          this.props.upsell.referencePriceType.price
                        )}
                      </span>
                    </span>
                  </span>
                  <span className="syos-pricetype-unit__action">
                    <button
                      className="syos-button"
                      onClick={() => {
                        this.handleSelection(price);
                      }}
                    >
                      Upgrade
                    </button>
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

InlineSeatUpsell.propTypes = {
  upsell: PropTypes.shape({
    seat: PropTypes.object,
    seatView: PropTypes.object,
    prices: PropTypes.arrayOf(PropTypes.object),
    referencePriceType: PropTypes.object
  }),
  handleSelection: PropTypes.func
};

export default InlineSeatUpsell;



// WEBPACK FOOTER //
// ./src/javascripts/components/InlineSeatUpsell.js